import { get } from 'lodash';
import * as React from 'react';
import { format, setMinutes, setHours } from 'date-fns';
import * as uuid from 'uuid/v4';
import { reduxForm } from 'redux-form';
import { Card } from 'material-ui/Card';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { Prompt, withRouter } from 'react-router';
import { compose, withProps, withHandlers } from 'recompose';
import { Grid, Row, Col } from 'react-flexbox-grid';

import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { AutoCompleteField, AutoComplete } from '@components/form';

import * as T from '@modules/hr-templates/periods/_periodsTypes';
import { Link } from 'react-router-dom';
import { getPeriodTemplate, createPeriodTemplate } from '@modules/hr-templates/periods/_periodsActions';
import EntityDetailEnhancer from '@components/hoc/entityDetailEnhancer/EntityDetailEnhancer';
import { PeriodTypesEnum } from '@modules/hr-templates/periods/_periodsEnums';
import { required } from '@utils/validators';
import { TimePickerField, CustomTimePicker } from '@components/form/TimePicker/TimePicker';

const linkBack = '/hr/templates/periods';

const convertTimeFromApi = time => {
  if (time) {
    const splits = time.split(':');
    return setHours(setMinutes(new Date(), splits[1]), splits[0]);
  } else {
    return null;
  }
};

const enhance = compose<T.PeriodsFormProps, T.PeriodsFormProps>(
  EntityDetailEnhancer<T.PeriodEnhancerProps<T.Period>, T.Period>({
    getEntity: getPeriodTemplate,
    defaultEntity: {}
  }),
  breadcrumbs(({ entity }) => [{ label: 'Intervaly', to: linkBack }, { label: get(entity, 'name', 'Nový interval') }]),
  withProps<{}, T.PeriodsForm>(({ entity }) => ({
    initialValues: {
      ...entity,
      from: get(entity, 'from') ? convertTimeFromApi(entity.from) : null,
      to: get(entity, 'to') ? convertTimeFromApi(entity.to) : null
    }
  })),
  withRouter,
  withHandlers({
    onSubmit: ({ location: { pathname }, history }) => async values => {
      const newValues = {
        ...values,
        from: format(values.from, 'HH:mm'),
        to: format(values.to, 'HH:mm'),
        id: values.id || uuid()
      };
      await createPeriodTemplate(newValues).then(() => history.push(pathname), error => console.debug(error));
    }
  }),
  reduxForm({
    form: 'module-template-days'
  })
);

const View: React.SFC<T.PeriodsFormProps> = props => (
  <div>
    <Prompt
      when={props.dirty && !props.submitSucceeded && !props.submitting}
      message="Vaše změny nebyly uloženy, přesto odejít?"
    />
    <form className="layout" onSubmit={props.handleSubmit}>
      <Card>
        <Grid fluid={true}>
          <Row>
            <Col className="grid-system-margin" />
          </Row>
          <Row>
            <Col md={12}>
              <Row>
                <Col md={12}>
                  <h4>Základní údaje</h4>
                </Col>
              </Row>
              <Row>
                <Col md={4}>
                  <TimePickerField component={CustomTimePicker} label="Od *" name="from" validate={[required]} />
                </Col>
                <Col md={4}>
                  <TimePickerField component={CustomTimePicker} label="Do *" name="to" validate={[required]} />
                </Col>
                <Col md={4}>
                  <AutoCompleteField
                    component={AutoComplete}
                    id="type"
                    name="type"
                    label="Typ intervalu *"
                    items={PeriodTypesEnum}
                    validate={[required]}
                    fullWidth={true}
                    labelFunction={o => get(o, 'label')}
                    valueFunction={o => get(o, 'id')}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Grid>
        <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} containerElement={<Link to={linkBack} />} />
      </Card>
    </form>
  </div>
);

export const PeriodsForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/hr-templates/periods/PeriodsForm.tsx